import Operation from "../index.js";

export default {
    //验证码
    registerVCode(phone, fn) {
        Operation.Http.post(`/sms/registerVCode?phone=${phone}`, null, fn)
    },
    //校验验证码
    checkVCode(params, fn) {
        let { phone, code } = params;
        Operation.Http.post(`/sms/checkVCode?phone=${phone}&code=${code}`, null, fn)
    },
    //找回密码时获取手机号验证码
    communityChangePassVCode(phone, fn) {
        Operation.Http.post(`/sms/communityChangePassVCode?phone=${phone}`, null, fn)
    },

}


// WEBPACK FOOTER //
// ./src/request/api/sms.js